import LocateTableModel from './locate-table-model.vue'
export default LocateTableModel
